export const generateBitMask = <F extends string = string>(fields: F[] = [], bits: Record<F, number>) => {
	return fields.reduce((total, name) => total | bits[name], 0);
};

export const checkBit = (value: number, bit: number) => !!(value & (1 << bit));
